function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import styled, { css } from "styled-components";
import PushStyles from "../../../helpers/PushStyles";
import breakpoint from "../../../utils/breakpoint";
import getBoldTypographyName from "../../../utils/getBoldTypographyName";
import getColor from "../../../utils/getColor";
import getFontWeight from "../../../utils/getFontWeight";
import getTextColor from "../../../utils/getTextColor";
import isObject from "../../../utils/isObject";
import space from "../../../utils/space";
import throwError from "../../../utils/throwError";
import unit from "../../../utils/unit";
import { defaultProps } from "./TextAtm.props";
var getPushSpaceStyles = function getPushSpaceStyles(pushSpace, hasNoPushReset) {
  return css(["", " ", ""], typeof pushSpace === "number" && css(["margin-bottom:", ";"], space(pushSpace)), isObject(pushSpace) && css(["", ";"], PushStyles(pushSpace, !hasNoPushReset, "space", "margin")));
};
var basicStyles = function basicStyles(fontSize, fontWeight, letterSpacing, lineHeightSpace) {
  return css(["font-size:", ";font-weight:", ";letter-spacing:", ";line-height:", ";white-space:pre-line;"], fontSize && unit(fontSize), fontWeight && getFontWeight(fontWeight), letterSpacing && unit(letterSpacing), lineHeightSpace && space(lineHeightSpace));
};
export var cssTextAtm = function cssTextAtm(_ref) {
  var typography = _ref.typography,
    onColor = _ref.onColor,
    _ref$emphasis = _ref.emphasis,
    emphasis = _ref$emphasis === void 0 ? defaultProps.emphasis : _ref$emphasis,
    color = _ref.color,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? defaultProps.align : _ref$align,
    isBold = _ref.isBold,
    pushSpace = _ref.pushSpace,
    hasNoPushReset = _ref.hasNoPushReset,
    hasLineThrough = _ref.hasLineThrough,
    hasNonBreakingSpace = _ref.hasNonBreakingSpace,
    hasMinWidthFitContent = _ref.hasMinWidthFitContent,
    hasInheritedTypography = _ref.hasInheritedTypography,
    hasInheritedColor = _ref.hasInheritedColor,
    hasFitLineHeight = _ref.hasFitLineHeight;
  return css(function (_ref2) {
    var theme = _ref2.theme;
    if (!typography) {
      throwError('"typography" is not defined!');
    }
    if (!onColor && !color) {
      throwError('"onColor" nor "color" is not defined!');
    }
    var typographyValue = isBold ? getBoldTypographyName(theme, typography) : typography;
    var _ref3 = theme.typography[typographyValue] || {},
      fontSize = _ref3.fontSize,
      fontWeight = _ref3.fontWeight,
      letterSpacing = _ref3.letterSpacing,
      lineHeightSpace = _ref3.lineHeightSpace,
      isUppercase = _ref3.isUppercase,
      mobile = _ref3.mobile;
    var colorValue = color ? getColor(theme, color) : getTextColor(theme, onColor, emphasis);
    return css(["", " ", " ", " ", " ", " ", " ", " ", ""], !hasInheritedTypography && css(["", ";text-align:", ";text-transform:", ";", ""], basicStyles(fontSize, fontWeight, letterSpacing, lineHeightSpace), align !== "left" && align, isUppercase && "uppercase", !!mobile && css(["", "{", ";}"], breakpoint("small", "medium"), basicStyles(mobile.fontSize, mobile.fontWeight, mobile.letterSpacing, mobile.lineHeightSpace))), hasInheritedTypography && isBold && css(["", ";", ""], basicStyles(fontSize, fontWeight, letterSpacing, lineHeightSpace), !!mobile && css(["", "{", ";}"], breakpoint("small", "medium"), basicStyles(mobile.fontSize, mobile.fontWeight, mobile.letterSpacing, mobile.lineHeightSpace))), !hasInheritedColor && css(["color:", ";"], colorValue), !!pushSpace && getPushSpaceStyles(pushSpace, !!hasNoPushReset), hasLineThrough && css(["text-decoration:line-through;"]), hasNonBreakingSpace && css(["white-space:nowrap;"]), hasMinWidthFitContent && css(["min-width:fit-content;"]), hasFitLineHeight && css(["line-height:1;"]));
  });
};
export var StyledTextAtm = styled.p.withConfig({
  componentId: "sc-pjfaic-0"
})(function (_ref4) {
  var $typography = _ref4.$typography,
    $onColor = _ref4.$onColor,
    $emphasis = _ref4.$emphasis,
    $color = _ref4.$color,
    $align = _ref4.$align,
    $isBold = _ref4.$isBold,
    $pushSpace = _ref4.$pushSpace,
    $hasNoPushReset = _ref4.$hasNoPushReset,
    $hasLineThrough = _ref4.$hasLineThrough,
    $hasNonBreakingSpace = _ref4.$hasNonBreakingSpace,
    $hasMinWidthFitContent = _ref4.$hasMinWidthFitContent,
    $hasInheritedTypography = _ref4.$hasInheritedTypography,
    $hasInheritedColor = _ref4.$hasInheritedColor,
    $hasFitLineHeight = _ref4.$hasFitLineHeight;
  var commonProps = {
    onColor: $onColor,
    emphasis: $emphasis,
    color: $color,
    align: $align,
    isBold: $isBold,
    pushSpace: $pushSpace,
    hasNoPushReset: $hasNoPushReset,
    hasLineThrough: $hasLineThrough,
    hasNonBreakingSpace: $hasNonBreakingSpace,
    hasMinWidthFitContent: $hasMinWidthFitContent,
    hasInheritedTypography: $hasInheritedTypography,
    hasInheritedColor: $hasInheritedColor,
    hasFitLineHeight: $hasFitLineHeight
  };
  if (_typeof($typography) === "object") {
    return css(["", ";", " ", " ", ""], cssTextAtm(_objectSpread({
      typography: $typography.small
    }, commonProps)), $typography.medium ? css(["", "{", ";}"], breakpoint("medium"), cssTextAtm(_objectSpread({
      typography: $typography.medium
    }, commonProps))) : null, $typography.large ? css(["", "{", ";}"], breakpoint("large"), cssTextAtm(_objectSpread({
      typography: $typography.large
    }, commonProps))) : null, $typography.huge ? css(["", "{", ";}"], breakpoint("huge"), cssTextAtm(_objectSpread({
      typography: $typography.huge
    }, commonProps))) : null);
  }
  return css(["", ";"], cssTextAtm(_objectSpread({
    typography: $typography
  }, commonProps)));
});